// Equivalent to $(el).outerWidth(true);
export function outerWidth(el) {
  var width = el.offsetWidth;
  var style = getComputedStyle(el);

  width += parseInt(style.marginLeft) + parseInt(style.marginRight);
  return width;
}

// Equivalent to $(el).outerHeight(true);
export function outerHeight(el) {
  var height = el.offsetHeight;
  var style = getComputedStyle(el);

  height += parseInt(style.marginTop) + parseInt(style.marginBottom);
  return height;
}

// Equivalent to $(el).empty();
export function empty(el) {
  el.innerHTML = '';
}

// Equivalent to $(el).addClass(className);
export function addClass(el, className) {
  if (className) {
    className = className.trim();
    if (className.length > 0) {
      if (el.classList) {
        el.classList.add(className);
      } else if (typeof el.className === 'string') {
        el.className += ' ' + className;
      } else if (typeof el.className === 'object') {
        // SVG className is of type SVGAnimatedString
        // IE 11 doesn't support classList
        let oldClassName = el.getAttribute('class') || '';
        el.setAttribute('class', oldClassName + ' ' + className);
      }
    }
  }
}

// Equivalent to $(el).removeClass(className);
export function removeClass(el, className) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(
      new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'),
      ' '
    );
  }
}

// Equivalent to $(el).hasClass(className);
export function hasClass(el, className) {
  var has;
  if (el.classList) {
    has = el.classList.contains(className);
  } else {
    has = new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
  }
  return has;
}

// Equivalent to $(el).toggleClass(className);
export function toggleClass(el, className) {
  if (hasClass(el, className)) {
    removeClass(el, className);
  } else {
    addClass(el, className);
  }
}

// Equivalent to $(el).position();
export function position(el) {
  return { left: el.offsetLeft, top: el.offsetTop };
}

// Equivalent to $(el).offset();
export function offset(el) {
  var rect = el.getBoundingClientRect();

  return {
    top: rect.top + document.body.scrollTop,
    left: rect.left + document.body.scrollLeft
  };
}

// Equivalent to $(el).closest(selector);
export function closest(el, selector) {
  var firstChar = selector.charAt(0);

  // Get closest match
  for (; el && el !== document; el = el.parentNode) {
    // If selector is a class
    if (firstChar === '.') {
      if (el.classList.contains(selector.substr(1))) {
        return el;
      }
    }

    // If selector is an ID
    if (firstChar === '#') {
      if (el.id === selector.substr(1)) {
        return el;
      }
    }

    // If selector is a data attribute
    if (firstChar === '[') {
      if (el.hasAttribute(selector.substr(1, selector.length - 2))) {
        return el;
      }
    }

    // If selector is a tag
    if (el.tagName.toLowerCase() === selector) {
      return el;
    }
  }

  return false;
}
